export const filtroMateriales = [
  {
    label: "Libro",
    value: "Libro",
  },
  {
    label: "Cassette",
    value: "Cassette",
  },
  {
    label: "CD-ROM",
    value: "CD-ROM",
  },
  {
    label: "Disco LP",
    value: "Disco LP",
  },
  {
    label: "Diskette",
    value: "Diskette",
  },
  {
    label: "Documento",
    value: "Documento",
  },
  {
    label: "DVD",
    value: "DVD",
  },
  {
    label: "Mapa",
    value: "Mapa",
  },
  {
    label: "Plano",
    value: "Plano",
  },
  {
    label: "Revista",
    value: "Revista",
  },
  {
    label: "Tesis",
    value: "Tesis",
  },
  {
    label: "Texto digital",
    value: "Digital",
  },
  {
    label: "VHS",
    value: "VHS",
  },
  {
    label: "Video digital",
    value: "Video",
  },
];

export const filtroBibliotecas = [
  {
    label: "Bib. Central",
    value: "central",
  },
  {
    label: "Bib. Colón",
    value: "colon",
  },
  {
    label: "Bib. David",
    value: "david",
  },
  {
    label: "Bib. Chitré",
    value: "chitre",
  },
  {
    label: "Postgrado",
    value: "postgrado",
  },
  {
    label: "Muser Mons. McGrath",
    value: "mons",
  },
  {
    label: "Bib. Santiago",
    value: "santiago",
  },
];
